export default __webpack_public_path__ + "static/media/codered.e5201c99.mp4";